import { Box, Button, FormControl, Grid, Grid2, InputAdornment, OutlinedInput, Paper, TextField, Typography, FormHelperText } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import signupImg from '../../assets/images/signup.png';
import passwordIcon from '../../assets/icons/Password.png';
import { useState, useEffect } from "react";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';

const RecoverPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [timer, setTimer] = useState(20);
    const [showResend, setShowResend] = useState(false);
    const operationsUrl = config.operationsUrl;
    const [otp, setOtp] = useState(Array(4).fill(''));
    const [enteredEmail, setEnteredEmail] = useState('');
    const [emailError, setEmailError] = useState('');

    const email = location.state?.email;

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEnteredEmail(value);
        if (value && !validateEmail(value)) {
            setEmailError('Please enter a valid email address');
        } else {
            setEmailError('');
        }
    };

    const backToSignUP = () => {
        navigate('/signup')
    }

    const resetPassword = async() => {
        if (password !== confirmPassword) {
            setMessage('Passwords do not match');
            return;
        }
        if (password.length < 6) {
            setMessage('Password must be at least 6 characters long');
            return;
        }
        const payload = {
            email: email ? email : enteredEmail,
            password: confirmPassword
        };
        // Add API call to reset password here
        try {
            const url = operationsUrl + '/admin-panel/reset_password';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                showSnackbar(true);
                console.log('Resetting password...');
                setMessage('Password reset successful');
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);

            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error:', error);
            setMessage(error);
        }
    }

    const sendOtpToEmail = async () => {
        // Validate email before sending OTP
        if (!email && !validateEmail(enteredEmail)) {
            setEmailError('Please enter a valid email address');
            return;
        }
        const payload = {
            email: email ? email : enteredEmail
        };
        try {
            const url = operationsUrl + '/admin-panel/reset_password_otp';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                showSnackbar(true);
                console.log('Sending OTP to:', email);
                setOtpSent(true);
                setMessage('OTP sent successfully');
                setTimer(20);
                setShowResend(false);
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const verifyOtp = async() => {
        const enteredOtp = otp.join('');
        if (enteredOtp.length !== 4) {
            setMessage('Please enter complete OTP');
            return;
        }
        const payload = {
            email: email ? email : enteredEmail,
            otp: otp.join('')
        };
        try {
            const url = operationsUrl + '/admin-panel/verify_reset_password_otp';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                showSnackbar(true);
                console.log('Verifying OTP:', enteredOtp);
                setOtpVerified(true);
                setMessage('OTP verified successfully');

            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (/^\d?$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            if (value && index < 3) {
                const nextInput = document.getElementById(`otp-input-${index + 1}`);
                if (nextInput) nextInput.focus();
            }
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            const prevInput = document.getElementById(`otp-input-${index - 1}`);
            if (prevInput) prevInput.focus();
        }
    };

    const handlePasswordChange = (e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        if (confirmPassword && newPassword !== confirmPassword) {
            setPasswordError('Passwords do not match');
        } else {
            setPasswordError('');
        }
    };

    const handleConfirmPasswordChange = (e) => {
        const newConfirmPassword = e.target.value;
        setConfirmPassword(newConfirmPassword);
        if (newConfirmPassword && password !== newConfirmPassword) {
            setPasswordError('Passwords do not match');
        } else {
            setPasswordError('');
        }
    };

    useEffect(() => {
        let interval;
        if (otpSent && timer > 0) {
            interval = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        } else if (timer === 0) {
            setShowResend(true);
        }
        return () => clearInterval(interval);
    }, [otpSent, timer]);

    return(
        <Paper elevation={3} style={{height:'97vh', width:'88vw', alignItems: 'center', justifyContent: 'center', margin: 'auto', borderRadius:'24px' }}>
            <Grid2 container spacing={2}  style={{margin:'2%', marginTop: '1%'}}>
                <Grid2 item size={{ xs: 12, md: 6, lg:6, xl:6 }} style={{marginTop:'2%'}}>
                    <img src={signupImg} alt="signup img" width="100%" height="82%" />
                </Grid2>

                <Grid2 item size={{ xs: 12, md: 5, lg:5, xl:5 }} style={{margin:'2%', marginTop:'10%'}} >
                    <Typography variant="h4" style={{fontWeight:700, fontSize:'32px'}}>Reset Password</Typography>
                    <Typography style={{color:'#83888E', fontSize:'16px'}}>Please enter below details</Typography>

                    <form onSubmit={(e) => e.preventDefault()}>
                        
                        {email!='' && (
                            <Grid2 style={{marginTop:'20px', display:'flex'}}>
                                <Typography>Email: </Typography>
                                <Typography sx={{marginLeft:'12px'}}>{email}</Typography>
                            </Grid2>
                        )}
                        {email=='' && (
                            <Grid2 style={{marginTop:'20px'}}>
                                <Typography>Email</Typography>
                                <FormControl variant="outlined" style={{marginTop:'2%'}} fullWidth error={!!emailError}>
                                    <OutlinedInput 
                                        type="email" 
                                        value={enteredEmail} 
                                        onChange={handleEmailChange}
                                        startAdornment={<InputAdornment position="start"><img src={passwordIcon} alt="password icon" width="24px" height="24px" /></InputAdornment>}
                                        placeholder="Enter your email"
                                    />
                                    {emailError && (
                                        <FormHelperText error>{emailError}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid2>
                        )}

                        {!otpSent && (
                            <Grid2 container alignItems="center" sx={{marginTop:'12px'}}>
                                <Grid2>
                                    <Button variant="contained" onClick={sendOtpToEmail} sx={{textTransform:'none'}}>Send OTP</Button>
                                </Grid2>
                            </Grid2>
                        )}

                        {otpSent && (
                            <Grid2 container alignItems="center" sx={{marginTop:'12px'}}>
                                <Grid2>
                                    <Button 
                                        onClick={sendOtpToEmail} 
                                        disabled={!showResend}
                                        sx={{
                                            textTransform: 'none',
                                            border: '1px solid #0065ff',
                                            color: showResend ? '#0065ff' : '#9e9e9e',
                                            borderColor: showResend ? '#0065ff' : '#9e9e9e',
                                            '&.Mui-disabled': {
                                                backgroundColor: '#f5f5f5'
                                            }
                                        }}
                                    >
                                        {showResend ? 'Resend OTP' : `Resend OTP (${timer}s)`}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        )}

                        {message && (
                            <Typography style={{ color: message.includes('success') ? 'green' : 'red', marginTop: '12px' }}>{message}</Typography>
                        )}

                        {otpSent && !otpVerified && (
                            <Grid2 style={{marginTop:'20px'}}>
                                <Typography>Enter OTP</Typography>
                                <Box display="flex" gap={2}>
                                    {otp.map((digit, index) => (
                                        <TextField 
                                            key={index} 
                                            id={`otp-input-${index}`} 
                                            value={digit}
                                            onChange={(e) => handleChange(e, index)}
                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                            inputProps={{
                                                maxLength: 1,
                                                style: { textAlign: 'center', fontSize: '20px' },
                                            }}
                                            sx={{
                                                width: '50px',
                                                '& input': {
                                                    padding: '10px',
                                                },
                                            }}
                                        />
                                    ))}
                                </Box>
                                <Button 
                                    variant="contained" 
                                    onClick={verifyOtp} 
                                    sx={{textTransform:'none', marginTop: 2}}
                                >
                                    Verify OTP
                                </Button>
                            </Grid2>
                        )}

                        {otpVerified && (
                            <>
                                <Grid2 style={{marginTop:'20px'}}>
                                    <Typography>Password</Typography>
                                    <FormControl variant="outlined" style={{marginTop:'2%'}} fullWidth>
                                        <OutlinedInput 
                                            type="password" 
                                            value={password} 
                                            onChange={handlePasswordChange}
                                            startAdornment={<InputAdornment position="start"><img src={passwordIcon} alt="password icon" width="24px" height="24px" /></InputAdornment>}
                                            placeholder="Enter your Password"
                                            error={!!passwordError}
                                        />
                                    </FormControl>
                                </Grid2>

                                <Grid2 style={{marginTop:'20px'}}>
                                    <Typography>Confirm Password</Typography>
                                    <FormControl variant="outlined" style={{marginTop:'2%'}} fullWidth>
                                        <OutlinedInput 
                                            type="password" 
                                            value={confirmPassword} 
                                            onChange={handleConfirmPasswordChange}
                                            startAdornment={<InputAdornment position="start"><img src={passwordIcon} alt="password icon" width="24px" height="24px" /></InputAdornment>}
                                            placeholder="Confirm your Password"
                                            error={!!passwordError}
                                        />
                                    </FormControl>
                                    {passwordError && (
                                        <Typography color="error" style={{fontSize: '12px', marginTop: '4px'}}>
                                            {passwordError}
                                        </Typography>
                                    )}
                                </Grid2>

                                <Grid2 container sx={{ marginTop: '12px', float:'right' }}>
                                    <Button 
                                        variant="contained" 
                                        onClick={resetPassword} 
                                        sx={{textTransform:'none'}}
                                        disabled={!!passwordError || !password || !confirmPassword}
                                    >
                                        Reset Password
                                    </Button>
                                </Grid2>
                            </>
                        )}
                    </form>
                </Grid2>
            </Grid2>
        </Paper>
    );
}

export default RecoverPassword;